module.exports = "/_next/static/images/QueryData-1@2x-92c8d1ee4a2085e379d0d5b3d1f3d5d9.webp";